import { render, staticRenderFns } from "./BirthdayModal.vue?vue&type=template&id=46862095&scoped=true"
import script from "./BirthdayModal.vue?vue&type=script&lang=js"
export * from "./BirthdayModal.vue?vue&type=script&lang=js"
import style0 from "./BirthdayModal.vue?vue&type=style&index=0&id=46862095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46862095",
  null
  
)

export default component.exports